module.exports = __webpack_public_path__ + "img/Observation.f47b42d4.jpg";